import React from 'react'
import { Box, Button, Typography } from "@mui/material";
import {
  TextFields,
  Notes,
  RadioButtonChecked,
  CheckBox,
  ArrowDropDownCircle,
  PlaylistAddCheck,
  ToggleOn,
    Star,
    UploadFile
} from "@mui/icons-material";
import { useSurveyStore } from '../surveyutilities/surveyStore';


function EcxSurveyToolbar() {
    const addQuestion = useSurveyStore(state => state.addQuestion);

     const items = [
    { key: "text", icon: <TextFields />, label: "Single-Line" },
    { key: "textarea", icon: <Notes />, label: "Multi-Line" },
    { key: "single_choice", icon: <RadioButtonChecked />, label: "Radio" },
    { key: "multiple_choice", icon: <CheckBox />, label: "Checkbox" },
    { key: "dropdown", icon: <ArrowDropDownCircle />, label: "Dropdown" },
    { key: "rating", icon: <Star />, label: "Rating" },
   /* { key: "file_upload", icon: <UploadFile />, label: "File Upload" },*/
  ];

     const addBlock = (questionType)=>{
         addQuestion(questionType);
     }
  return (
   <Box
       sx={{
        height: "100%", // fill the Grid cell
        bgcolor: "background.paper",
        borderRight: 1,
        borderColor: "divider",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: 2,
        gap: 1,
      }}
    >
      {items.map((item) => (
        <Button
          key={item.key}
          onClick={() => addBlock(item.key)}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "64px",
            minHeight: "64px",
            color: "text.primary",
            textTransform: "none",
            borderRadius: 2,
            "&:hover": {
              bgcolor: "action.hover",
            },
          }}
        >
          {item.icon}
          <Typography variant="caption" sx={{ fontSize: "0.65rem", mt: 0.5 }}>
            {item.label}
          </Typography>
        </Button>
      ))}
    </Box>
  )
}

export default EcxSurveyToolbar